import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from '../store';

/**
 * Typed dispatch hook for Redux actions.
 * Use throughout your app instead of plain `useDispatch` for full typing.
 * @example
 * const dispatch = useAppDispatch();
 * dispatch(selectElement('element-id'));
 * @returns Typed dispatch function
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/**
 * Typed selector hook for Redux state.
 * Use throughout your app instead of plain `useSelector` for full typing.
 * @example
 * const elements = useAppSelector(s => s.layout.elements);
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
